import { useTranslate } from 'context/languageContext';

export default function LanguagePresenter () {
    const t = useTranslate();

    const languageOptions = [
        {id:1, txt:t('lb_ca'), value:'ca', selected:false },
        {id:2, txt:t('lb_es'), value:'es', selected:false },
        {id:3, txt:t('lb_en'), value:'en', selected:false },
        // {id:4, txt:t('lb_de'), value:'de', selected:false },
      ];

    return { languageOptions } as const;
}
